/**
 * Content Batch Service
 */

import { httpClient } from '../http-client';
import type { ContentStyle } from '@careertree/shared';

const API_BASE_URL = '/api/v1';

/**
 */
export type ContentBatchStatus =
  | 'PENDING'
  | 'RUNNING'
  | 'COMPLETED'
  | 'FAILED'
  | 'PARTIAL'
  | 'CANCELLED';

/**
 */
export type ContentNodeBatchStatus =
  | 'PENDING'
  | 'RUNNING'
  | 'COMPLETED'
  | 'FAILED'
  | 'SKIPPED';

/**
 */
export interface ContentBatch {
  id: string;
  learningTreeId: string;
  userId: string;
  status: ContentBatchStatus;
  workflowId: string | null;
  totalNodes: number;
  completedNodes: number;
  failedNodes: number;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
  startedAt: string | null;
  completedAt: string | null;
  batchNodes: ContentBatchNode[];
}

/**
 */
export interface ContentBatchNode {
  id: string;
  batchId: string;
  nodeId: string;
  status: ContentNodeBatchStatus;
  order: number;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  node?: {
    id: string;
    title: string;
    depth: number;
    contentStatus: string;
  };
}

/**
 */
export interface CreateBatchResponse {
  batchId: string;
  workflowId: string;
  nodeCount: number;
  status: string;
}

export const ContentBatchService = {
async createBatch(
    treeId: string,
    nodeIds: string[],
    contentStyle?: ContentStyle
  ): Promise<CreateBatchResponse> {
    const url = `${API_BASE_URL}/learning-trees/${treeId}/content-batches`;

    const response = await httpClient.post<CreateBatchResponse>(url, { nodeIds, contentStyle });
    return response.data;
  },

  /**
   */
  async listBatches(treeId: string): Promise<ContentBatch[]> {
    const url = `${API_BASE_URL}/learning-trees/${treeId}/content-batches`;

    const response = await httpClient.get<ContentBatch[]>(url);
    return response.data;
  },

  /**
   */
  async getBatch(batchId: string): Promise<ContentBatch> {
    const url = `${API_BASE_URL}/content-batches/${batchId}`;

    const response = await httpClient.get<ContentBatch>(url);
    return response.data;
  },

  /**
   */
  async cancelBatch(batchId: string): Promise<{ message: string; batchId: string }> {
    const url = `${API_BASE_URL}/content-batches/${batchId}/cancel`;

    const response = await httpClient.post<{ message: string; batchId: string }>(url);
    return response.data;
  },
};
